import type { Section } from "./types";

/*
 * Section registry — drives navigation, routing, and topic pages.
 * Each section has its own distinct hero placeholder image featuring
 * African American editorial/lifestyle subjects (Handoff v3 §2).
 */

export const sections: Section[] = [
  {
    slug: "the-tea",
    name: "The Tea",
    tagline: "Pour a glass — here's the tea.",
    description:
      "Commentary, culture, and conversation with attitude. Porsha's unfiltered take on what everyone is talking about — and what they should be.",
    heroImage: "/manus-storage/hero-the-tea_734a5c49.png",
    heroImageAlt:
      "Two stylish African American women laughing over cocktails at an upscale lounge",
    heroMood: "Conversational · Warm lounge tones · Attitude",
    navOrder: 1,
  },
  {
    slug: "fashion",
    name: "Fashion",
    tagline: "Style is a language. Speak it fluently.",
    description:
      "Runway energy, luxury lookbooks, and the looks worth your attention — from couture moments to the accessories that finish a fit.",
    heroImage: "/manus-storage/hero-fashion_854f416d.png",
    heroImageAlt:
      "African American model in gold and black couture gown under a runway spotlight",
    heroMood: "Runway luxury · High contrast · Dramatic",
    navOrder: 2,
  },
  {
    slug: "travel",
    name: "Travel",
    tagline: "Check in like you own the view.",
    description:
      "Destination guides, luxury stays, and golden-hour itineraries — how to move through the world with style and intention.",
    heroImage: "/manus-storage/hero-travel_4a90a4c9.png",
    heroImageAlt:
      "Elegant African American woman on a hotel balcony overlooking a coastal city at golden hour",
    heroMood: "Destination glow · Golden-hour warmth",
    navOrder: 3,
  },
  {
    slug: "haute-to-watch",
    name: "Haute to Watch",
    tagline: "The names you will know next.",
    description:
      "Entrepreneurs, creators, and brands building something worth watching — modern mogul energy, profiled before everyone else catches on.",
    heroImage: "/manus-storage/hero-haute-to-watch_75ada7b3.png",
    heroImageAlt:
      "Successful African American woman entrepreneur in a cream suit in a dark penthouse office",
    heroMood: "Modern mogul · Sleek · Elevated",
    navOrder: 4,
  },
  {
    slug: "detroit",
    name: "Detroit Guide",
    tagline: "Detroit after dark, according to Porsha.",
    description:
      "The city's soul, block by block — restaurants, record shops, culture, and the people making Detroit move.",
    heroImage: "/manus-storage/hero-detroit_138cd30d.png",
    heroImageAlt:
      "Stylish African American man walking through downtown Detroit at blue hour",
    heroMood: "City soul · Urban night warmth",
    navOrder: 5,
  },
  {
    slug: "things-to-do",
    name: "Things to Do",
    tagline: "Your weekend called. It has plans.",
    description:
      "Concerts, nightlife, exhibits, and city activity — the curated calendar of where to be and be seen.",
    heroImage: "/manus-storage/hero-things-to-do_81307a71.png",
    heroImageAlt:
      "Fashionable African American friends at a rooftop concert under string lights",
    heroMood: "Nightlife · Electric · Social",
    navOrder: 6,
  },
  {
    slug: "current-events",
    name: "Current Events",
    tagline: "The story behind the headline.",
    description:
      "Timely coverage with context and relevance — what happened, why it matters, and what Porsha thinks about it.",
    heroImage: "/manus-storage/hero-current-events-v2_582b4294.png",
    heroImageAlt:
      "Poised African American journalist at a modern broadcast desk with warm studio lights",
    heroMood: "Timely media · Crisp newsroom editorial",
    navOrder: 7,
  },
  {
    slug: "date-night",
    name: "Date Night",
    tagline: "Romance, reservations required.",
    description:
      "Romantic restaurants, lounges and cocktail spots, weekend couple ideas, luxury experiences, city dates, travel date-night concepts, seasonal guides, and curated his & hers moments.",
    heroImage: "/manus-storage/hero-date-night_58b09e1b.png",
    heroImageAlt:
      "Elegant African American couple sharing a candlelit toast at a fine dining restaurant",
    heroMood: "Romantic elegance · Candlelit violet tones",
    navOrder: 8,
    topics: [
      "Romantic Restaurants",
      "Lounges & Cocktail Spots",
      "Weekend Couple Ideas",
      "Luxury Experiences",
      "City Date Ideas",
      "Travel Date Nights",
      "Seasonal Guides",
      "His & Hers",
    ],
  },
];

export const getSection = (slug: string) =>
  sections.find((s) => s.slug === slug);
